export default __webpack_public_path__ + "static/media/laptop_work.65b0d1b2.jpg";